const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPbScopeG(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "scope",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 205.57 58.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M26,38.01c3.14,0,5.81,1.02,8.01,3.06,2.22,2.04,3.33,4.49,3.33,7.36s-1.11,5.31-3.33,7.34c-2.22,2.04-4.89,3.06-8.01,3.06H2.11l4.15-9.3h19.74c.57,0,1.06-.13,1.49-.4.37-.24.56-.47.56-.7s-.19-.46-.56-.7c-.42-.27-.92-.41-1.49-.41h-14.65c-3.12,0-5.79-1.02-8.01-3.06-2.22-2.04-3.33-4.5-3.33-7.36s1.11-5.31,3.33-7.34c2.22-2.04,4.89-3.06,8.01-3.06h25.17l-4.15,9.3H11.34c-.57,0-1.07.13-1.49.4-.38.24-.56.47-.56.7s.19.46.56.7c.42.27.91.41,1.49.41h14.65Z",
    style: {
      fill: "#a7a9ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.21,58.83h-21.34c-3.12,0-5.79-1.11-8.01-3.33-2.22-2.22-3.33-4.89-3.33-8.01v-9.63c0-3.12,1.11-5.79,3.33-8.01,2.22-2.22,4.89-3.33,8.01-3.33h21.34l-3.62,9.3h-17.71c-.56,0-1.04.2-1.44.61-.41.41-.61.88-.61,1.44v9.63c0,.55.2,1.03.61,1.44.4.41.88.61,1.44.61h18.46l2.88,9.3Z",
    style: {
      fill: "#a7a9ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.58,58.83c-3.12,0-5.79-1.11-8.01-3.33-2.22-2.22-3.33-4.89-3.33-8.01v-9.63c0-3.12,1.11-5.79,3.33-8.01,2.22-2.22,4.89-3.33,8.01-3.33h14.65c3.12,0,5.79,1.11,8.01,3.33,2.22,2.22,3.33,4.89,3.33,8.01v9.63c0,3.12-1.11,5.79-3.33,8.01-2.22,2.22-4.89,3.33-8.01,3.33h-14.65ZM87.58,35.81c-.56,0-1.04.2-1.44.61-.41.41-.61.89-.61,1.44v9.63c0,.55.2,1.03.61,1.44.4.41.88.61,1.44.61h14.65c.55,0,1.04-.2,1.44-.61.4-.41.61-.89.61-1.44v-9.63c0-.56-.2-1.03-.61-1.44-.4-.4-.89-.61-1.44-.61h-14.65Z",
    style: {
      fill: "#a7a9ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.3,26.51c3.12,0,5.79,1.11,8.01,3.33,2.22,2.22,3.33,4.89,3.33,8.01v1.76c0,3.14-1.11,5.81-3.33,8.01-2.22,2.22-4.89,3.33-8.01,3.33h-16.7v7.88h-9.3V26.51h26ZM145.35,37.85c0-.56-.2-1.03-.61-1.44-.41-.4-.89-.61-1.44-.61h-16.7v5.85h16.7c.55,0,1.04-.2,1.44-.61.4-.41.61-.89.61-1.44v-1.76Z",
    style: {
      fill: "#a7a9ac"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.96 26.51 187.04 35.81 169.77 35.81 169.77 38.82 181.94 38.82 182.4 46.52 169.77 46.52 169.77 49.53 189.01 49.53 193.16 58.83 160.48 58.83 160.48 26.51 191.96 26.51",
    style: {
      fill: "#a7a9ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.2,26.38v-1.07c0-.64-1.14-1.21-2.86-1.21s-2.86.56-2.86,1.21v3.48c0,.1.13.16.35.16h1c.22,0,.35-.06.35-.16v-1.2c0-.07.08-.08.21-.07.27.04.54.07.95.07,1.71,0,2.86-.56,2.86-1.21M201.5,26.38c0,.25-.41.52-1.16.52-.75,0-1.16-.27-1.16-.52v-1.07c0-.25.41-.52,1.16-.52s1.16.27,1.16.52v1.07Z",
    style: {
      fill: "#a7a9ac",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.14,28.96c0,1.14-1.75,2.34-4.91,2.34s-4.91-1.2-4.91-2.34v-4.82c0-1.14,1.75-2.34,4.91-2.34s4.9,1.2,4.91,2.34v4.82Z",
    style: {
      fill: "none",
      stroke: "#a7a9ac",
      strokeMiterlimit: 3.86,
      strokeWidth: ".86px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M63.13.72c.69-.11,1.59-.21,2.73-.21,1.41,0,2.44.33,3.09.92.61.52.97,1.32.97,2.31s-.29,1.78-.85,2.36c-.75.8-1.98,1.21-3.37,1.21-.43,0-.82-.02-1.14-.1v4.42h-1.42V.72ZM64.55,6.04c.31.08.7.11,1.18.11,1.72,0,2.76-.83,2.76-2.36s-1.03-2.16-2.6-2.16c-.62,0-1.1.05-1.34.11v4.29Z",
    style: {
      fill: "#c0c2c4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.54,7.59c0,2.93-2.03,4.2-3.94,4.2-2.14,0-3.8-1.57-3.8-4.07,0-2.65,1.73-4.2,3.93-4.2s3.81,1.65,3.81,4.07ZM72.26,7.67c0,1.73,1,3.04,2.4,3.04s2.4-1.29,2.4-3.08c0-1.34-.67-3.04-2.37-3.04s-2.44,1.57-2.44,3.07Z",
    style: {
      fill: "#c0c2c4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.82,3.7l1.05,4.02c.23.88.44,1.7.59,2.52h.05c.18-.8.44-1.65.7-2.5l1.29-4.04h1.21l1.23,3.96c.29.95.52,1.78.7,2.58h.05c.13-.8.34-1.64.61-2.57l1.13-3.97h1.42l-2.55,7.92h-1.31l-1.21-3.78c-.28-.88-.51-1.67-.7-2.6h-.03c-.2.95-.44,1.77-.72,2.62l-1.28,3.76h-1.31l-2.39-7.92h1.47Z",
    style: {
      fill: "#c0c2c4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.93,7.92c.03,1.95,1.28,2.75,2.72,2.75,1.03,0,1.65-.18,2.19-.41l.25,1.03c-.51.23-1.37.49-2.63.49-2.44,0-3.89-1.6-3.89-3.99s1.41-4.27,3.71-4.27c2.58,0,3.27,2.27,3.27,3.73,0,.29-.03.52-.05.67h-5.56ZM97.15,6.89c.02-.92-.38-2.34-2-2.34-1.46,0-2.09,1.34-2.21,2.34h4.2Z",
    style: {
      fill: "#c0c2c4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.33,6.17c0-.93-.02-1.73-.07-2.47h1.26l.05,1.55h.07c.36-1.06,1.23-1.73,2.19-1.73.16,0,.28.02.41.05v1.36c-.15-.03-.29-.05-.49-.05-1.01,0-1.73.77-1.93,1.85-.03.2-.07.42-.07.67v4.22h-1.42v-5.45Z",
    style: {
      fill: "#c0c2c4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.32,7.92c.03,1.95,1.28,2.75,2.72,2.75,1.03,0,1.65-.18,2.19-.41l.25,1.03c-.51.23-1.37.49-2.63.49-2.44,0-3.89-1.6-3.89-3.99s1.41-4.27,3.71-4.27c2.58,0,3.27,2.27,3.27,3.73,0,.29-.03.52-.05.67h-5.56ZM110.54,6.89c.02-.92-.38-2.34-2-2.34-1.46,0-2.09,1.34-2.21,2.34h4.2Z",
    style: {
      fill: "#c0c2c4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.56,0v9.57c0,.7.02,1.5.07,2.04h-1.29l-.07-1.37h-.03c-.44.88-1.41,1.55-2.7,1.55-1.91,0-3.39-1.62-3.39-4.02-.02-2.63,1.62-4.25,3.55-4.25,1.21,0,2.03.57,2.39,1.21h.03V0h1.44ZM119.12,6.92c0-.18-.02-.43-.07-.61-.21-.92-1-1.67-2.08-1.67-1.49,0-2.37,1.31-2.37,3.06,0,1.6.78,2.93,2.34,2.93.97,0,1.85-.64,2.11-1.72.05-.2.07-.39.07-.62v-1.37Z",
    style: {
      fill: "#c0c2c4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.35,11.61c.03-.54.07-1.34.07-2.04V0h1.42v4.97h.03c.51-.88,1.42-1.46,2.7-1.46,1.96,0,3.35,1.64,3.34,4.04,0,2.83-1.78,4.24-3.55,4.24-1.14,0-2.06-.44-2.65-1.49h-.05l-.07,1.31h-1.24ZM127.84,8.44c0,.18.03.36.07.52.28,1,1.11,1.68,2.16,1.68,1.51,0,2.41-1.23,2.41-3.04,0-1.59-.82-2.94-2.36-2.94-.98,0-1.9.67-2.19,1.77-.03.16-.08.36-.08.59v1.42Z",
    style: {
      fill: "#c0c2c4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.14,3.7l1.73,4.68c.18.52.38,1.14.51,1.62h.03c.15-.47.31-1.08.51-1.65l1.57-4.65h1.52l-2.16,5.64c-1.03,2.72-1.73,4.11-2.71,4.96-.7.62-1.41.87-1.77.93l-.36-1.21c.36-.11.83-.34,1.26-.7.39-.31.88-.87,1.21-1.6.07-.15.11-.26.11-.34s-.03-.2-.1-.38l-2.93-7.3h1.57Z",
    style: {
      fill: "#c0c2c4"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPbScopeG);
export default __webpack_public_path__ + "static/media/pb-scope-g.1bdf051396a5b54b44cf4075df1eed2d.svg";
export { ForwardRef as ReactComponent };